// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .studies-grid-con{
    height: 100%;
 }
 
 .studies-grid-con tr[aria-rowindex="2"] {
  display: none;
}



.studies-right-con .header{
   height: 38.5px;
   padding: 0;
   margin: 0;
   display: flex;
   align-items: center;
   gap: 300px;
   background-color:var(--grid-header-color);
   font-weight: bold;
   font-size: 14px;
}

.studies-right-con .header span:first-child{
   margin-left: 20px;
}

.studies-right-con .k-animation-container{
   width: 100% !important;
}

.studies-right-con .k-tabstrip-content{
   padding-block: 5px;
   padding-inline: 5px;
}

/* custom-cell */

.custom-cell {
  padding: 6px 8px;
}

.cell-value {
  display: block;
  margin-bottom: 20px;
}

/* Horizontal container */
.cell-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

/* Each field block */
.field-group {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.field-group label {
  margin-bottom: 4px;
  font-weight: 500;
  color: #555;
}

/* Inputs */
.field-group input {
  padding: 4px 6px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.field-group input[type="number"] {
  width: 70px;
}

.field-group input[type="text"] {
  width: 160px;
}

.field-group input:focus {
  outline: none;
  border-color: #1976d2;
}


`, "",{"version":3,"sources":["webpack://./src/view/studies/index.css"],"names":[],"mappings":"CAAC;IACG,YAAY;CACf;;CAEA;EACC,aAAa;AACf;;;;AAIA;GACG,cAAc;GACd,UAAU;GACV,SAAS;GACT,aAAa;GACb,mBAAmB;GACnB,UAAU;GACV,yCAAyC;GACzC,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[" .studies-grid-con{\n    height: 100%;\n }\n \n .studies-grid-con tr[aria-rowindex=\"2\"] {\n  display: none;\n}\n\n\n\n.studies-right-con .header{\n   height: 38.5px;\n   padding: 0;\n   margin: 0;\n   display: flex;\n   align-items: center;\n   gap: 300px;\n   background-color:var(--grid-header-color);\n   font-weight: bold;\n   font-size: 14px;\n}\n\n.studies-right-con .header span:first-child{\n   margin-left: 20px;\n}\n\n.studies-right-con .k-animation-container{\n   width: 100% !important;\n}\n\n.studies-right-con .k-tabstrip-content{\n   padding-block: 5px;\n   padding-inline: 5px;\n}\n\n/* custom-cell */\n\n.custom-cell {\n  padding: 6px 8px;\n}\n\n.cell-value {\n  display: block;\n  margin-bottom: 20px;\n}\n\n/* Horizontal container */\n.cell-row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n/* Each field block */\n.field-group {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n}\n\n.field-group label {\n  margin-bottom: 4px;\n  font-weight: 500;\n  color: #555;\n}\n\n/* Inputs */\n.field-group input {\n  padding: 4px 6px;\n  font-size: 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.field-group input[type=\"number\"] {\n  width: 70px;\n}\n\n.field-group input[type=\"text\"] {\n  width: 160px;\n}\n\n.field-group input:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
